// Versão do app - gerado automaticamente
export const APP_VERSION = '5.55'
export const BUILD_DATE = '04/10/2026, 06:24'
